import LinkedText from "../LinkedText";
import SozcukAppIcon from "../../assets/img/games/sozcukApp/sozcukApp.png";

export default function GamesTable() {
    const iconStyle = {
        width: "1.5em",
        height: "1.5em",
        objectFit: "contain",
        flexShrink: 0,
        display: "block",
        marginLeft: 0
    };

    const gameTitleStyle = {
        display: "flex",
        alignItems: "center",
        gap: "5px",
    };

    const freeStyle = {
        fontWeight: "bold",
        color: "#2aef0c",
    };
    
    return (
        <>
            <h2 style={gameTitleStyle}><img style={iconStyle} src={SozcukAppIcon} alt={"SozcukApp"}/>sözcük.app <span style={freeStyle}>(Free)</span></h2>
            <p className="mb-0">A challenging word games that refreshes daily.
                            <br/>Click <LinkedText href={"https://sozcukapp.com"} text={"here"}/> to learn more.
            </p>
        </>
    )
}
